import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";


import Error404 from "../pages/error/error-404";
import Login2 from "../auth/login/login-2";
import TwoStepVerification3 from "../auth/twoStepVerification/twoStepVerification-3";
import Register3 from "../auth/register/register-3";
import ForgotPassword3 from "../auth/forgotPassword/forgotPassword-3";

import Profile from "../pages/profile";
import Activity from "../administration/help-support/activity";
import ManageApproval from "../administration/manage-approval/manageApproval";
import AllDashboard from "../mainMenu/allDashboard/index";
import LicenseRegistrationForm from "../pages/license-registration-form";
import Preview from "../pages/license-registration-form/preview";
import Pending from "../mainMenu/MyApplication/Pending";
import Approved from "../mainMenu/MyApplication/Approved";
import Rejected from "../mainMenu/MyApplication/Rejected";
import MyApplications from "../mainMenu/coReview";
import RectificationComponent from "../mainMenu/coReview/rectificationComponent";
import PanelEngineerProfile from "../mainMenu/profilePage_Component";
import TraderRectificationComponent from "../mainMenu/coReview/TraderRectificationComponent";
import PanelEngineerApplication from "../mainMenu/Panel_Engineer_MyApplication/PanelEngineerApplication";
import PendingPE from "../mainMenu/Panel_Engineer_MyApplication/Pending";
import PaymentSuccess from "../pages/license-registration-form/paymentstatus";
import PendingToClerk from "../application/PendingToClerk";
import ToClerkAfterApproval from "../application/ToClerkAfterApproval";
import ForRejection from "../application/ForRejection";
import PreviewApplication from "../application/previewApplication";

import RazorPays from "../pages/license-registration-form/razor_pay";
import PanelEngineerLicenseRegistrationForm from "../pages/PanelEngineerForm";

import PannelEnginnerDashboard from "../mainMenu/PannelEngineerDashboard";
import GCA_Dashboard from "../mainMenu/gcaDashboard/index"


import PanelPending from "../ApplicationsPannelEngineer/Pending";
import PaymentInitiate from "../pages/license-registration-form/InitiatePayment";
import ResetPasswordModal from "../auth/resetPasswordSuccess/resetPassword";
import PanelPreview from "../pages/PanelEngineerForm/preview";
import PreviewPanelApplication from "../ApplicationsPannelEngineer/Preview";
import FirstApproval from "../application/FirstApproval";
import Rejection from "../ApplicationsPannelEngineer/Rejected";
import ApprovedPanel from "../ApplicationsPannelEngineer/Approved";
import ApplicationPreview from "../pages/PanelEngineerForm/DownloadApplication";
import APMC from "../schemes/apmc";
import District from "../schemes/district";
import MenuAPMC from "../schemes/menu";
import SchemeSelector from "../schemes/AllSchemes/SchemeSelector";
import JCForwardForm from "../schemes/CertificateForm";
import ApmcPending from "../apllicationApmc/Pending";
import ApprovedApmc from "../apllicationApmc/Approved";
import RejectionApmc from "../apllicationApmc/Rejected";
import DistrictRegistar from "../schemes/annexure/index";
import SchemeSelectorLand from "../schemes/LandPurchaseSale/Schemes";
import PurchaseApmc from "../schemes/LandPurchaseSale/components/purchase/PurchaseApmc";
import SellApmc from "../schemes/LandPurchaseSale/components/sell/SellApmc";
import PurchaseDistrict from "../schemes/LandPurchaseSale/components/purchase/PurchaseDistrict";
import SellDistrict from "../schemes/LandPurchaseSale/components/sell/SellDistrict";
import AllForms from "../schemes/allPages";
import DistrictAllForms from "../schemes/LandDistrict";
import ApmcFormApplication from "../mainMenu/ApmcFormApplications/ApmcFormApplicatiion";
import ApmcFormPending from "../applicationFormApmc/Pending";
import ApprovedFormApmc from "../applicationFormApmc/Approved";
import RejectionFormApmc from "../applicationFormApmc/Rejected";
import GCALicenseRegistrationForm from "../pages/gca-license-registration-form";
import GcaAgentApplication from "../mainMenu/Gca_Application/GcaApplication";
import SchemesQueryTable from "../schemes/RejectionTables/Schemes/component/APMC";
import SeniorAuthorityTable from "../schemes/RejectionTables/Schemes/component/APMC";
import FormsAuthorityTable from "../schemes/RejectionTables/Forms/APMC";
import FormsAuthorityDistrictTable from "../schemes/RejectionTables/Forms/District";
import SchemesAuthorityDistrictTable from "../schemes/RejectionTables/Schemes/component/district";
import SchemesDownload from "../schemes/DownloadForm/Download";
import PreviewGca from "../pages/gca-license-registration-form/preview";
import GcaPreviewApplication from "../applicationGca/PreviewGcaApplication";
import GcaApproval from "../applicationGca/ApprovalGca";
import PendingSecretary from "../applicationGca/PendingSecretary";
import GcaRejection from "../applicationGca/RejectionGca";
import ClassificationFormAPMC from "../schemes/classificationForm/APMC";
import ClassificationFormDistrict from "../schemes/classificationForm/District";
import SponsorRegistrationIndex from "../ContractFarming/Sponsor/Registration";
import RegistrationStatus from "../ContractFarming/Sponsor/Registration/components/RegistrationStatus";
import MarketingBoardRegIndex from "../ContractFarming/MarketingBoard/Registration";
// import DashboardFormK from "../ContractFarming/MarketingBoard/Registration/components/DashboardMenuFormK";
// import MDFormL from "../ContractFarming/MarketingBoard/Registration/components/MDFormL";
import SponsorAgreement from "../ContractFarming/Sponsor/Agreement";
import MarketingBoardAgreement from "../ContractFarming/MarketingBoard/Agreement";
import SponsorDashboard from "../ContractFarming/Sponsor/menu";
import StampPaperSponsor from "../ContractFarming/Sponsor/StampPaper";
import CertificateMD from "../ContractFarming/MarketingBoard/StampPaper/components/CertificateMD";
import SponsorRegistrationP3 from "../ContractFarming/Sponsor/Registration/components/Page3";
import MenuMarketingBoardRegistration from "../ContractFarming/MarketingBoard/Menu/Registration";
import MenuMarketingBoardAgreement from "../ContractFarming/MarketingBoard/Menu/Agreement";

import PDFView from "../ContractFarming/MarketingBoard/StampPaper/PDFView"
import SponsorRegsitrationMenu from "../ContractFarming/Sponsor/menu/SponsorRegistrationMenu";
import ReadOnlyAgreementForm from "../ContractFarming/Sponsor/Agreement/components/ReadOnlyAgreementForm";
import ApmcSponsorRegPending from "../applicationSponsorReg/Pending";
import RejectionSponsorRegApmc from "../applicationSponsorReg/Rejected";
import ApprovedSponsorReg from "../applicationSponsorReg/Approved";
import ApmcSponsorAgrPending from "../applicationSponsorAgr/Pending";
import RejectionSponsorAgrApmc from "../applicationSponsorAgr/Rejected";
import ApprovedSponsorAgr from "../applicationSponsorAgr/Approved";
import DownloadExcelMIS from "../MIS_excel/downloadXL";
// import UploadExcelMIS from "../MIS_excel/input/components/uploadXL";
import MISInput from "../MIS_excel/input";
import MISPreview from "../MIS_excel/input/components/MisPreview";
import MISApproval from "../applicationMIS/Preview";
import MISMyApplication from "../mainMenu/MIS_MyApplication";
import ApprovedMIS from "../applicationMIS/Approved";
import PendingMIS from "../applicationMIS/Pending";
import MISAfterApprovalHO from "../MIS_department/MIS_HO";
import MISPreviewScreen from "../mainMenu/MIS_MyApplication/MISPreviewScreen";
import RaiseQueryMISMenu from "../applicationMIS/RaiseQuery";
import RaiseQueryMIS from "../MIS_department/MIS_RaiseQuery";
import ApmcDetailApplicationForm from "../pages/ApmcDetailApplication/components/ApmcDetailApplicationForm";
import Index from "../pages/ApmcDetailApplication/index"
import PendingOneTime from "../applicationOneTime/Pending";
import ApprovedOneTime from "../applicationOneTime/Approve";
import RasieQueryOneTime from "../applicationOneTime/RaiseQuery";
import ApmcOneTimeFormApplication from "../mainMenu/ApmcOneTime/apmcOneTime";
import APMCFormView from "../pages/ApmcDetailApplication/components/previewDetailApplication";
import APMCPreviewDepartment from "../applicationOneTime/previewOneTimeApplication";
import AboutDetailsMore from "../../core/common/homePage/components/aboutMore";
// import FirstApproval from "../application/FirstApproval";
// import ApproveResubmission from "../application/ApproveResubmission";





const routes = all_routes;

export const  authRoutes= [

  {
    path: routes.allDashboard,
    element: <AllDashboard/>,
     route: Route,
  },
  {
    path: routes.PannelEnginnerDashboard,
    element: <PannelEnginnerDashboard/>,
     route: Route,
  },
  {
    path: routes.GCADashboard,
    element: <GCA_Dashboard/>,
     route: Route,
  },
  {
    path: routes.licenseRegistrationForm,
    element: <LicenseRegistrationForm />,
    route: Route,
  },
  {
    path: routes.panelRegistrationForm,
    element: <PanelEngineerLicenseRegistrationForm />,
    route: Route,
  },
  {
    path: routes.paymentInitiate,
    element: <PaymentInitiate />,
    route: Route,
  },

  // MIS
    {
    path: routes.misXLupload,
    element: <MISPreview />,
    route: Route,
  },
    {
    path: routes.misInput,
    element: <MISInput />,
    route: Route,
  },
    {
    path: routes.misXLdownload,
    element: <DownloadExcelMIS />,
    route: Route,
  },
  {
    path: routes.MISApproval,
    element: <MISApproval />,
    route: Route,
  },
   {
    path: routes.MISPreviewScreen,
    element: <MISPreviewScreen />,
    route: Route,
  },
  {
    path: routes.MISMyApplication,
    element: <MISMyApplication />,
    route: Route,
  },
  {
    path: routes.ApprovedMIS,
    element: <ApprovedMIS />,
    route: Route,
  },
  {
    path: routes.PendingMIS,
    element: <PendingMIS />,
    route: Route,
  },
  {
    path: routes.RaiseQueryMISMenu,
    element: <RaiseQueryMISMenu />,
    route: Route,
  },
  {
    path: routes.MISAfterApproval,
    element: <MISAfterApprovalHO />,
    route: Route,
  },
  {
    path: routes.MISRaiseQuery,
    element: <RaiseQueryMIS />,
    route: Route,
  },


  //apmc
    {
    path: routes.apmc,
    element: <APMC />,
    route: Route,
  },
  {
    path: routes.district,
    element: <District />,
    route: Route,
  },
  {
    path: routes.menu,
    element: <MenuAPMC />,
    route: Route,
  },
   {
    path: routes.formApmcApplication,
    element: <ApmcFormApplication />,
    route: Route,
  },
    {
    path: routes.allSchemes,
    element: <SchemeSelector />,
    route: Route,
  },
   {
    path: routes.jcForm,
    element: <JCForwardForm />,
    route: Route,
  },
  //  {
  //   path: routes.downloadSchemes,
  //   element: <SchemesDownload />,
  //   route: Route,
  // },
  {
    path: routes.districtRegistrar,
    element: <DistrictRegistar />,
    route: Route,
  },
  {
    path: routes.landSchemes,
    element: <SchemeSelectorLand />,
    route: Route,
  },
  {
    path: routes.purchaseApmc,
    element: <PurchaseApmc />,
    route: Route,
  },
  {
    path: routes.sellApmc,
    element: <SellApmc />,
    route: Route,
  },
  {
    path: routes.sellDistrict,
    element: <SellDistrict />,
    route: Route,
  },
  {
    path: routes.purchaseDistrict,
    element: <PurchaseDistrict />,
    route: Route,
  },
  {
    path: routes.allForms,
    element: <AllForms />,
    route: Route,
  },
   {
    path: routes.districtAllForms,
    element: <DistrictAllForms />,
    route: Route,
  },
  {
    path: routes.schemeQuery,
    element: <SeniorAuthorityTable />,
    route: Route,
  },
  {
    path: routes.formQuery,
    element: <FormsAuthorityTable />,
    route: Route,
  },
  {
    path: routes.formQueryDistrict,
    element: <FormsAuthorityDistrictTable />,
    route: Route,
  },
  {
    path: routes.schemesQueryDistrict,
    element: <SchemesAuthorityDistrictTable />,
    route: Route,
  },
  {
    path: routes.classificationFormAPMC,
    element: <ClassificationFormAPMC />,
    route: Route,
  },
  {
    path: routes.classificationFormDistrict,
    element: <ClassificationFormDistrict />,
    route: Route,
  },

  //One Time Application
   {
    path: routes.apmcDetailApplication,
    element: <Index />,
    route: Route,
  },
    {
    path: routes.myApmcOneTimeApplication,
    element: <ApmcOneTimeFormApplication />,
    route: Route,
  },
   {
    path: routes.myApmcOneTimeApplicationPreview,
    element: <APMCFormView />,
    route: Route,
  },
   {
    path: routes.apmcPreviewDepartment,
    element: <APMCPreviewDepartment />,
    route: Route,
  },
   {
    path: routes.pendingOneTime,
    element: <PendingOneTime />,
    route: Route,
  },
   {
    path: routes.approvedOneTime,
    element: <ApprovedOneTime />,
    route: Route,
  },
   {
    path: routes.raiseQueryOneTime,
    element: <RasieQueryOneTime />,
    route: Route,
  },

  //Contract Farming
  {
    path: routes.sponsorRegistration,
    element: <SponsorRegistrationIndex />,
    route: Route,
  },
    {
    path: routes.pdfDocReview,
    element: <PDFView />,
    route: Route,
  },
    {
    path: routes.agreFormDownload,
    element: <ReadOnlyAgreementForm />,
    route: Route,
  },
  {
    path: routes.paymentSuccess,
    element: <SponsorRegistrationP3 />,
    route: Route,
  },
  {
    path: routes.registrationStatus,
    element: <RegistrationStatus />,
    route: Route,
  },
  {
    path: routes.marketingBoardRegistration,
    element: <MarketingBoardRegIndex />,
    route: Route,
  },
  {
    path: routes.menuMarketingBoardReg,
    element: <MenuMarketingBoardRegistration />,
    route: Route,
  },
  {
    path: routes.menuMarketingBoardAgreement,
    element: <MenuMarketingBoardAgreement />,
    route: Route,
  },
   {
    path: routes.sponsorRegistrationPending,
    element: <ApmcSponsorRegPending />,
    route: Route,
  },
    {
    path: routes.sponsorRegistrationRaiseQuery,
    element: <RejectionSponsorRegApmc />,
    route: Route,
  },
    {
    path: routes.sponsorRegistrationApproved,
    element: <ApprovedSponsorReg />,
    route: Route,
  },
     {
    path: routes.sponsorAgreementPending,
    element: <ApmcSponsorAgrPending />,
    route: Route,
  },
    {
    path: routes.sponsorAgreementRaiseQuery,
    element: <RejectionSponsorAgrApmc />,
    route: Route,
  },
    {
    path: routes.sponsorAgreementApproved,
    element: <ApprovedSponsorAgr />,
    route: Route,
  },
  {
    path: routes.sponsorAgreement,
    element: <SponsorAgreement />,
    route: Route,
  },
  {
    path: routes.mbAgreement,
    element: <MarketingBoardAgreement />,
    route: Route,
  },
  {
    path: routes.sponsorDashboard,
    element: <SponsorDashboard />,
    route: Route,
  },
  {
    path: routes.stampPaperSponsor,
    element: <StampPaperSponsor />,
    route: Route,
  },
  {
    path: routes.certificateMD,
    element: <CertificateMD />,
    route: Route,
  },
  {
    path: routes.spoRegMenu,
    element: <SponsorRegsitrationMenu />,
    route: Route,
  },
  

//gca-Application
{path: routes.gcaLicenseRegistrationForm,
element: <GCALicenseRegistrationForm />,
route: Route,
},
  //Application
  {
    path: routes.previewAppDepartment,
    element: <PreviewApplication />,
    route: Route,
  },
  {
    path: routes.previewGcaAppDepartment,
    element: <GcaPreviewApplication />,
    route: Route,
  },
  {
    path: routes.approveGca,
    element: < GcaApproval/>,
    route: Route,
  },
  {
    path: routes.rejectionGca,
    element: < GcaRejection/>,
    route: Route,
  },
  {
    path: routes.pendingGca,
    element: < PendingSecretary/>,
    route: Route,
  },

  {
    path: routes.previewPanelAppDepartment,
    element: <PreviewPanelApplication />,
    route: Route,
  },
  {
    path: routes.pending,
    element: <PendingToClerk />,
    route: Route,
  },
  {
    path: routes.firstapproved,
    element: <FirstApproval />,
    route: Route,
  },
  {
    path: routes.panelRejection,
    element: <Rejection />,
    route: Route,
  },
  {
    path: routes.panelApproved,
    element: <ApprovedPanel />,
    route: Route,
  },
  {
    path: routes.rejection,
    element: <ForRejection />,
    route: Route,
  },
  {
    path: routes.pending_panel,
    element: <PanelPending />,
    route: Route,
  },

  {
    path: routes.forRejection,
    element: <ForRejection />,
    route: Route,
  },
  {
    path: routes.approveUnsigned,
    element: <ToClerkAfterApproval />,
    route: Route,
  },
  {
    path: routes.GcaMyApplication,
    element: <GcaAgentApplication />,
    route: Route,
  },

  {
    path: routes.previewGcaOneApplication,
    element: <PreviewGca />,
    route: Route,
  },
  
  {
    path: routes.traderPending,
    element: <Pending />,
    route: Route,
  },
  {
    path: routes.previewOneApplication,
    element: <Preview />,
    route: Route,
  },
  {
    path: routes.paymentStatus,
    element: <PaymentSuccess />,
    route: Route,
  },
  
  {
    path: routes.myApplicationPanel,
    element: <PanelEngineerApplication />,
    route: Route,
  },
  {
    path: routes.previewPanelApplication,
    element: <PanelPreview />,
    route: Route,
  },
  {
    path: routes.pendingPanel,
    element: <PendingPE />,
    route: Route,
  },
 
 


  {
    path: routes.Preview,
    element: <Preview />,
    route: Route,
  },
  {
    path: routes.razorPay,
    element: <RazorPays />,
    route: Route,
  },
 
  {
    path: routes.approved,
    element: <Approved />,
    route: Route,
  },
  {
    path: routes.rejected,
    element: <Rejected />,
    route: Route,
  },

  {
    path: routes.myApplication,
    element: <MyApplications />,
    route: Route,
  },

  {
    path: routes.rectification,
    element: <RectificationComponent />,
    route: Route,
  },

  {
    path: routes.profile,
    element: <Profile />,
  },
  {
    path: routes.panelEngineerProfile,
    element: <PanelEngineerProfile />,
  },

  {
    path: routes.traderRectificationComponent,
    element: <TraderRectificationComponent />,
  },
  
  {
    path: routes.manage_apmc,
    element: <Activity />,
  },
  {
    path: routes.manage_approval,
    element: <ManageApproval />,
  },
   {
    path: routes.apmcPendingApp,
    element: <ApmcPending />,
    route: Route,
  },
   {
    path: routes.apmcApprovedApp,
    element: <ApprovedApmc />,
    route: Route,
  },
  {
    path: routes.apmcRejectedApp,
    element: <RejectionApmc />,
    route: Route,
  },
    {
    path: routes.apmcFormsPendingApp,
    element: <ApmcFormPending />,
    route: Route,
  },
   {
    path: routes.apmcFormsApprovedApp,
    element: <ApprovedFormApmc />,
    route: Route,
  },
  {
    path: routes.apmcFormsRejectedApp,
    element: <RejectionFormApmc />,
    route: Route,
  },


];

export const publicRoutes = [


  {
    path: routes.login2,
    element: <Login2 />,
    route: Route,
  },
  {
    path: routes.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: routes.aboutNew,
    element: <AboutDetailsMore />,
    route: Route,
  },

 
 
  {
    path: routes.twoStepVerification3,
    element: <TwoStepVerification3 />,
    route: Route,
  },

  {
    path: routes.register3,
    element: <Register3 />,
    route: Route,
  },
 
  
  {
    path: routes.forgotPassword3,
    element: <ForgotPassword3 />,
    route: Route,
  },
  {
    path: routes.resetPasswordModal,
    element: <ResetPasswordModal email={""} username={""} refId={""} visible={false} onClose={function (): void {
      throw new Error("Function not implemented.");
    } } />,
    route: Route,
  },
 
];
